/*
 * House of D'oro – product image zoom (replaces Dawn's click-to-zoom).
 * Desktop / mouse: a round magnifying glass follows the cursor over product photos;
 * clicking opens the full-screen image viewer.
 * Phone / tablet: touch and hold a product photo to get the same magnifying glass (it sits just
 * above the finger and follows it); a quick tap opens the full-screen image viewer.
 * Image viewer: dark full-screen lightbox with counter, full screen, share, zoom and close buttons,
 * previous/next arrows, click or double-tap to zoom, drag to pan, pinch, swipe and keyboard control.
 */
(function () {
  if (window.__doroHoverZoom) return;
  window.__doroHoverZoom = true;

  var ZOOM = 2.5; // magnification inside the glass
  var LENS = 220; // glass diameter in px (smaller on small images)
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
  var lens = null;
  var current = null;

  function removeLens() {
    if (current) {
      current.style.cursor = '';
      current.removeEventListener('mousemove', onMove);
      current.removeEventListener('mouseleave', removeLens);
    }
    if (lens) lens.remove();
    lens = null;
    current = null;
  }

  function onMove(event) {
    if (!lens || !current) return;
    var r = current.getBoundingClientRect();
    var x = event.clientX - r.left;
    var y = event.clientY - r.top;
    if (x < 0 || y < 0 || x > r.width || y > r.height) {
      removeLens();
      return;
    }
    var half = lens.__size / 2;
    lens.style.left = event.clientX - half + 'px';
    lens.style.top = event.clientY - half + 'px';
    lens.style.backgroundSize = r.width * ZOOM + 'px ' + r.height * ZOOM + 'px';
    lens.style.backgroundPosition = -(x * ZOOM - half) + 'px ' + -(y * ZOOM - half) + 'px';
  }

  function showLens(image, event) {
    if (current === image) return;
    removeLens();
    current = image;
    var r = image.getBoundingClientRect();
    var size = Math.round(Math.min(LENS, r.width * 0.45));

    lens = document.createElement('div');
    lens.className = 'doro-lens';
    lens.__size = size;
    lens.setAttribute('aria-hidden', 'true');
    var s = lens.style;
    s.position = 'fixed';
    s.display = 'block'; // Dawn hides empty divs (div:empty), so set it explicitly
    s.width = s.height = size + 'px';
    s.borderRadius = '50%';
    s.border = '3px solid rgba(255,255,255,.95)';
    s.boxShadow = '0 6px 24px rgba(0,0,0,.28), inset 0 0 0 1px rgba(0,0,0,.08)';
    s.backgroundColor = '#fff';
    s.backgroundRepeat = 'no-repeat';
    s.backgroundImage = 'url("' + (image.currentSrc || image.src) + '")';
    s.pointerEvents = 'none';
    s.zIndex = '50';
    s.opacity = '0';
    s.transition = 'opacity .15s ease';
    document.body.appendChild(lens);

    // Swap in the largest image once it has loaded, so the magnified view stays sharp.
    var full = image.getAttribute('src');
    if (full && full !== image.currentSrc) {
      var hi = new Image();
      var thisLens = lens;
      hi.onload = function () {
        thisLens.style.backgroundImage = 'url("' + full + '")';
      };
      hi.src = full;
    }

    image.style.cursor = 'none';
    image.addEventListener('mousemove', onMove);
    image.addEventListener('mouseleave', removeLens);
    onMove(event);
    void lens.offsetWidth; // force a reflow so the fade-in transition runs
    lens.style.opacity = '1';
  }

  function openLightbox(image) {
    var opener = image.closest('modal-opener');
    var toggle = opener && opener.querySelector('.product__media-toggle');
    if (toggle) toggle.click();
  }

  // Event delegation keeps working after Dawn re-renders the gallery on variant change.
  document.addEventListener('mouseover', function (event) {
    if (!mq.matches) return;
    var t = event.target;
    var image = t && t.closest ? t.closest('img.image-magnify-hover') : null;
    if (image) showLens(image, event);
  });
  document.addEventListener('click', function (event) {
    if (!mq.matches) return;
    var t = event.target;
    var image = t && t.closest ? t.closest('img.image-magnify-hover') : null;
    if (!image) return;
    removeLens();
    openLightbox(image);
  });
  window.addEventListener('scroll', removeLens, { passive: true });
  window.addEventListener('resize', removeLens);
})();

/* ---------- Phone / tablet: touch-and-hold magnifying glass on gallery photos ---------- */
(function () {
  if (window.__doroTouchLens) return;
  window.__doroTouchLens = true;

  var ZOOM = 2.5; // magnification inside the glass
  var HOLD_MS = 200; // how long to hold before the glass appears
  var MOVE_TOLERANCE = 10; // px of movement allowed before it counts as a scroll/swipe
  var GAP = 36; // space between fingertip and glass
  var touchMq = window.matchMedia('(hover: none), (pointer: coarse)');

  var lens = null;
  var img = null;
  var timer = null;
  var startPt = null;
  var lastTouch = null;
  var active = false;
  var suppressClickUntil = 0;

  function addStyles() {
    if (document.getElementById('doro-lens-css')) return;
    var st = document.createElement('style');
    st.id = 'doro-lens-css';
    st.textContent =
      'media-gallery img.image-magnify-hover,media-gallery .product__media-toggle{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}' +
      '.doro-lens-hint{position:absolute;left:50%;bottom:1.2rem;transform:translateX(-50%);z-index:3;display:block;padding:.6rem 1.4rem;border-radius:2rem;background:rgba(18,18,18,.75);color:#fff;font-size:1.2rem;line-height:1.3;letter-spacing:.03rem;white-space:nowrap;pointer-events:none;transition:opacity .4s ease}' +
      '.doro-lens-hint.gone{opacity:0}';
    document.head.appendChild(st);
  }

  function findImage(target) {
    if (!target || !target.closest || !target.closest('media-gallery')) return null;
    var opener = target.closest('modal-opener');
    return opener ? opener.querySelector('img.image-magnify-hover') : null;
  }

  function place(t) {
    if (!lens || !img) return;
    var r = img.getBoundingClientRect();
    var x = Math.max(0, Math.min(r.width, t.clientX - r.left));
    var y = Math.max(0, Math.min(r.height, t.clientY - r.top));
    var half = lens.__size / 2;
    var cx = Math.max(half + 6, Math.min(window.innerWidth - half - 6, t.clientX));
    var cy = t.clientY - half - GAP; // above the finger so it isn't hidden under it
    if (cy - half < 6) cy = t.clientY + half + GAP; // flip below near the top of the screen
    lens.style.left = cx - half + 'px';
    lens.style.top = cy - half + 'px';
    lens.style.backgroundSize = r.width * ZOOM + 'px ' + r.height * ZOOM + 'px';
    lens.style.backgroundPosition = -(x * ZOOM - half) + 'px ' + -(y * ZOOM - half) + 'px';
  }

  function open() {
    if (!img || !lastTouch) return;
    active = true;
    var r = img.getBoundingClientRect();
    var size = Math.round(Math.min(170, r.width * 0.5));
    lens = document.createElement('div');
    lens.className = 'doro-lens doro-lens--touch';
    lens.__size = size;
    lens.setAttribute('aria-hidden', 'true');
    var s = lens.style;
    s.position = 'fixed';
    s.display = 'block'; // Dawn hides empty divs (div:empty), so set it explicitly
    s.width = s.height = size + 'px';
    s.borderRadius = '50%';
    s.border = '3px solid rgba(255,255,255,.95)';
    s.boxShadow = '0 8px 28px rgba(0,0,0,.32), inset 0 0 0 1px rgba(0,0,0,.08)';
    s.backgroundColor = '#fff';
    s.backgroundRepeat = 'no-repeat';
    s.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    s.pointerEvents = 'none';
    s.zIndex = '60';
    s.opacity = '0';
    s.transform = 'scale(.6)';
    s.transition = 'opacity .12s ease, transform .12s ease';
    document.body.appendChild(lens);

    var full = img.getAttribute('src');
    if (full && full !== img.currentSrc) {
      var hi = new Image();
      var thisLens = lens;
      hi.onload = function () {
        thisLens.style.backgroundImage = 'url("' + full + '")';
      };
      hi.src = full;
    }

    place(lastTouch);
    void lens.offsetWidth; // force a reflow so the pop-in transition runs
    s.opacity = '1';
    s.transform = 'scale(1)';
    hideHint();
  }

  function close() {
    clearTimeout(timer);
    timer = null;
    if (lens) lens.remove();
    lens = null;
    if (active) suppressClickUntil = Date.now() + 500; // don't open the lightbox after magnifying
    active = false;
    img = null;
    startPt = null;
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!touchMq.matches) return;
      if (e.touches.length !== 1) {
        close();
        return;
      }
      var target = findImage(e.target);
      if (!target) return;
      addStyles();
      img = target;
      lastTouch = e.touches[0];
      startPt = { x: lastTouch.clientX, y: lastTouch.clientY };
      clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        open();
      }, HOLD_MS);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!img) return;
      var t = e.touches[0];
      if (!t) return;
      lastTouch = t;
      if (active) {
        e.preventDefault(); // keep the page and gallery still while magnifying
        place(t);
        return;
      }
      if (startPt && Math.hypot(t.clientX - startPt.x, t.clientY - startPt.y) > MOVE_TOLERANCE) {
        clearTimeout(timer); // it's a scroll or swipe, not a hold
        timer = null;
        img = null;
      }
    },
    { passive: false }
  );

  function onEnd(e) {
    if (e.touches && e.touches.length) return;
    if (img || active) close();
  }
  document.addEventListener('touchend', onEnd);
  document.addEventListener('touchcancel', onEnd);

  document.addEventListener(
    'click',
    function (e) {
      if (Date.now() < suppressClickUntil) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );
  // Android long-press menu ("Download image") would interrupt the glass.
  document.addEventListener(
    'contextmenu',
    function (e) {
      if (touchMq.matches && (active || findImage(e.target))) e.preventDefault();
    },
    true
  );

  // One-time hint so shoppers know the glass exists.
  var hint = null;
  function hideHint() {
    if (!hint) return;
    var h = hint;
    hint = null;
    h.classList.add('gone');
    setTimeout(function () {
      h.remove();
    }, 450);
  }
  function showHint() {
    if (!touchMq.matches) return;
    try {
      if (sessionStorage.getItem('doroLensHint')) return;
      sessionStorage.setItem('doroLensHint', '1');
    } catch (err) {
      /* storage unavailable: just show it */
    }
    var item = document.querySelector('media-gallery .product__media-item');
    if (!item) return;
    addStyles();
    if (getComputedStyle(item).position === 'static') item.style.position = 'relative';
    hint = document.createElement('div');
    hint.className = 'doro-lens-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = 'Hold to magnify · Tap to enlarge';
    item.appendChild(hint);
    setTimeout(hideHint, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showHint);
  else showHint();
})();

/* ---------- Full-screen image viewer (replaces Dawn's product image modal) ---------- */
(function () {
  if (window.__doroLightbox) return;
  window.__doroLightbox = true;

  var TAP_ZOOM = 2.5; // zoom used by the zoom button, double-click and double-tap
  var MAX_ZOOM = 4; // largest pinch zoom
  var SWIPE = 50; // px needed to change photo
  var FULL_WIDTH = 2400; // size of the photo loaded in the viewer

  var ICONS = {
    full: '<path d="M15 3h6v6"/><path d="M21 3l-7 7"/><path d="M9 21H3v-6"/><path d="M3 21l7-7"/>',
    share: '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4"/><path d="M15.4 6.5l-6.8 4"/>',
    zoomIn: '<circle cx="11" cy="11" r="7"/><path d="M20.5 20.5L16 16"/><path d="M11 8v6"/><path d="M8 11h6"/>',
    zoomOut: '<circle cx="11" cy="11" r="7"/><path d="M20.5 20.5L16 16"/><path d="M8 11h6"/>',
    close: '<path d="M6 6l12 12"/><path d="M18 6L6 18"/>',
    prev: '<path d="M15 6l-6 6 6 6"/>',
    next: '<path d="M9 6l6 6-6 6"/>'
  };
  function svg(name, cls) {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"' +
      (cls ? ' class="' + cls + '"' : '') +
      '>' +
      ICONS[name] +
      '</svg>'
    );
  }

  var CSS =
    '.doro-lb{position:fixed;inset:0;z-index:2147483000;display:flex;flex-direction:column;background:rgba(0,0,0,.95);color:#fff;opacity:0;transition:opacity .25s ease;font-family:inherit}' +
    '.doro-lb[hidden]{display:none}' +
    '.doro-lb.is-open{opacity:1}' +
    '.doro-lb svg{width:2.4rem;height:2.4rem;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}' +
    '.doro-lb__bar{position:relative;z-index:2;display:flex;justify-content:space-between;align-items:center;width:100%;padding:1.6rem;transition:background .2s ease}' +
    '.doro-lb.is-zoomed .doro-lb__bar{background:linear-gradient(rgba(0,0,0,.6),rgba(0,0,0,0))}' +
    '.doro-lb__counter{font-size:1.8rem;font-weight:500;letter-spacing:.1em}' +
    '.doro-lb__actions{display:flex;align-items:center;gap:1.2rem}' +
    '.doro-lb__icon{display:inline-flex;padding:.4rem;border:0;background:none;color:#fff;line-height:0;cursor:pointer;transition:color .2s ease}' +
    '.doro-lb__icon:hover{color:#d1d5db}' +
    '.doro-lb__icon[hidden],.doro-lb__zoom-out,.doro-lb.is-zoomed .doro-lb__zoom-in{display:none}' +
    '.doro-lb.is-zoomed .doro-lb__zoom-out{display:block}' +
    '.doro-lb__body{position:relative;flex:1;min-height:0;display:flex;align-items:center;justify-content:center;overflow:hidden;padding:0 1.6rem}' +
    '.doro-lb__frame{position:relative;width:100%;height:100%;max-width:85vh;margin:0 auto}' +
    '.doro-lb__stage{position:relative;width:100%;height:100%;cursor:zoom-in;touch-action:none;user-select:none;-webkit-user-select:none;transition:transform .3s ease}' +
    '.doro-lb.is-zoomed .doro-lb__stage{cursor:grab}' +
    '.doro-lb__stage.is-dragging{cursor:grabbing;transition:none}' +
    '.doro-lb__img{position:absolute;inset:0;width:100%;height:100%;max-width:none;object-fit:contain;pointer-events:none;transition:opacity .4s ease;-webkit-user-drag:none}' +
    '.doro-lb__img.is-loading{opacity:0}' +
    '.doro-lb__nav{position:absolute;top:50%;z-index:2;display:inline-flex;padding:1.2rem;border:.1rem solid rgba(255,255,255,.1);border-radius:50%;background:rgba(0,0,0,.2);color:#fff;cursor:pointer;transform:translateY(-50%);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);transition:background-color .2s ease}' +
    '.doro-lb__nav:hover{background:rgba(0,0,0,.4)}' +
    '.doro-lb__nav--prev{left:1.6rem}' +
    '.doro-lb__nav--next{right:1.6rem}' +
    '.doro-lb--single .doro-lb__nav{display:none}' +
    '.doro-lb.is-zoomed .doro-lb__nav{opacity:0;pointer-events:none}' +
    '.doro-lb :focus-visible{outline:.2rem solid #fff;outline-offset:.3rem}' +
    '.doro-lb .doro-lb__toast{position:absolute;bottom:calc(3.2rem + env(safe-area-inset-bottom,0px));left:50%;z-index:3;display:block;padding:.8rem 1.6rem;border-radius:10rem;background:rgba(255,255,255,.15);font-size:1.4rem;white-space:nowrap;opacity:0;pointer-events:none;transform:translateX(-50%);transition:opacity .2s ease}' +
    '.doro-lb .doro-lb__toast.is-visible{opacity:1}' +
    // keep floating app buttons (e.g. WhatsApp) from covering the viewer
    '.doro-lightbox-open [class^="ai-whatsapp-float"],.doro-lightbox-open [class*=" ai-whatsapp-float"]{visibility:hidden!important}' +
    '@media screen and (min-width:576px){.doro-lb__actions{gap:2.4rem}}' +
    '@media screen and (min-width:750px){.doro-lb__bar{position:absolute;top:0;left:0;padding:2.4rem 3.2rem}.doro-lb__counter{font-size:2rem}.doro-lb__actions{gap:3.2rem}.doro-lb__body{padding:0 9.6rem}.doro-lb__nav--prev{left:3.2rem}.doro-lb__nav--next{right:3.2rem}}' +
    '@media (prefers-reduced-motion:reduce){.doro-lb,.doro-lb__bar,.doro-lb__stage,.doro-lb__img{transition:none}}';

  function clamp(v, min, max) {
    return Math.min(max, Math.max(min, v));
  }

  // Photos come from the product gallery each time the viewer opens, so variant changes are picked up.
  function collectItems() {
    var items = [];
    var seen = {};
    document.querySelectorAll('media-gallery .product__media-toggle[data-media-id]').forEach(function (toggle) {
      var id = toggle.getAttribute('data-media-id');
      var opener = toggle.closest('modal-opener');
      var img = opener && opener.querySelector('.product__modal-opener--image img, img.image-magnify-hover');
      if (!img || seen[id]) return;
      seen[id] = true;
      var src = img.getAttribute('src') || img.currentSrc || '';
      src = /[?&]width=\d+/.test(src)
        ? src.replace(/([?&])width=\d+/, '$1width=' + FULL_WIDTH)
        : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + FULL_WIDTH;
      items.push({ id: id, src: src, alt: img.getAttribute('alt') || '' });
    });
    return items;
  }

  var lb, stage, frame, imgEl, currentEl, totalEl, toastEl, zoomBtn;
  var items = [];
  var index = 0;
  var trigger = null;
  var st = { s: 1, x: 0, y: 0 };
  var pointers = {};
  var drag = null;
  var pinch = null;
  var lastTap = { t: 0, x: 0, y: 0 };
  var hideTimer, toastTimer;

  function build() {
    if (lb) return;
    var style = document.createElement('style');
    style.id = 'doro-lb-css';
    style.textContent = CSS;
    document.head.appendChild(style);

    lb = document.createElement('div');
    lb.className = 'doro-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    lb.innerHTML =
      '<div class="doro-lb__bar">' +
      '<div class="doro-lb__counter" aria-live="polite"><span data-lb-current>1</span> / <span data-lb-total>1</span></div>' +
      '<div class="doro-lb__actions">' +
      '<button type="button" class="doro-lb__icon" data-lb-fullscreen aria-label="Full screen">' + svg('full') + '</button>' +
      '<button type="button" class="doro-lb__icon" data-lb-share aria-label="Share">' + svg('share') + '</button>' +
      '<button type="button" class="doro-lb__icon" data-lb-zoom aria-label="Zoom in">' + svg('zoomIn', 'doro-lb__zoom-in') + svg('zoomOut', 'doro-lb__zoom-out') + '</button>' +
      '<button type="button" class="doro-lb__icon" data-lb-close aria-label="Close">' + svg('close') + '</button>' +
      '</div></div>' +
      '<div class="doro-lb__body">' +
      '<button type="button" class="doro-lb__nav doro-lb__nav--prev" data-lb-prev aria-label="Previous image">' + svg('prev') + '</button>' +
      '<div class="doro-lb__frame"><div class="doro-lb__stage" data-lb-stage><img class="doro-lb__img" data-lb-img alt="" draggable="false"></div></div>' +
      '<button type="button" class="doro-lb__nav doro-lb__nav--next" data-lb-next aria-label="Next image">' + svg('next') + '</button>' +
      '</div>' +
      '<div class="doro-lb__toast" data-lb-toast role="status"></div>';
    document.body.appendChild(lb);

    stage = lb.querySelector('[data-lb-stage]');
    frame = lb.querySelector('.doro-lb__frame');
    imgEl = lb.querySelector('[data-lb-img]');
    currentEl = lb.querySelector('[data-lb-current]');
    totalEl = lb.querySelector('[data-lb-total]');
    toastEl = lb.querySelector('[data-lb-toast]');
    zoomBtn = lb.querySelector('[data-lb-zoom]');
    if (!document.fullscreenEnabled) lb.querySelector('[data-lb-fullscreen]').hidden = true;

    lb.addEventListener('click', onClick);
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onCancel);
    stage.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });
    imgEl.addEventListener('load', function () {
      imgEl.classList.remove('is-loading');
    });
    imgEl.addEventListener('error', function () {
      imgEl.classList.remove('is-loading');
    });
  }

  function open(i, opener) {
    build();
    items = collectItems();
    if (!items.length) return false;
    clearTimeout(hideTimer);
    trigger = opener || document.activeElement;
    lb.classList.toggle('doro-lb--single', items.length < 2);
    totalEl.textContent = items.length;
    lb.hidden = false;
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('doro-lightbox-open');
    show(i);
    void lb.offsetWidth; // force a reflow so the fade-in transition runs
    lb.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    lb.querySelector('[data-lb-close]').focus({ preventScroll: true });
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) {
      var seen = false;
      try {
        seen = !!sessionStorage.getItem('doroLbHint');
        sessionStorage.setItem('doroLbHint', '1');
      } catch (err) {
        /* storage unavailable */
      }
      if (!seen) toast('Pinch or double-tap to zoom', 2600);
    }
    return true;
  }

  function close() {
    if (!lb || lb.hidden) return;
    if (document.fullscreenElement === lb) document.exitFullscreen().catch(function () {});
    lb.classList.remove('is-open');
    setZoom(1, 0, 0);
    document.removeEventListener('keydown', onKey);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('doro-lightbox-open');
    hideTimer = setTimeout(function () {
      lb.hidden = true;
    }, 250);
    if (trigger && trigger.focus) trigger.focus({ preventScroll: true });
  }

  function show(i) {
    var n = items.length;
    if (!n) return;
    index = ((i % n) + n) % n;
    var item = items[index];
    setZoom(1, 0, 0);
    if (imgEl.getAttribute('src') !== item.src) {
      imgEl.classList.add('is-loading');
      imgEl.src = item.src;
    }
    imgEl.alt = item.alt;
    currentEl.textContent = index + 1;
    [1, -1].forEach(function (step) {
      var next = items[(index + step + n) % n];
      if (next) new Image().src = next.src; // preload neighbours
    });
  }

  // ---- zoom / pan ----
  function limits(s) {
    return { x: (frame.offsetWidth * (s - 1)) / 2, y: (frame.offsetHeight * (s - 1)) / 2 };
  }
  function setZoom(s, x, y) {
    st.s = s;
    var m = limits(s);
    st.x = clamp(x, -m.x, m.x);
    st.y = clamp(y, -m.y, m.y);
    var zoomed = s > 1.01;
    lb.classList.toggle('is-zoomed', zoomed);
    if (zoomBtn) zoomBtn.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
    stage.style.transform = zoomed ? 'translate(' + st.x + 'px,' + st.y + 'px) scale(' + s + ')' : '';
  }
  // Zoom in on the point that was clicked or tapped (or zoom back out).
  function zoomAt(clientX, clientY) {
    if (st.s > 1.01) {
      setZoom(1, 0, 0);
      return;
    }
    var r = frame.getBoundingClientRect();
    var px = clientX - (r.left + r.width / 2);
    var py = clientY - (r.top + r.height / 2);
    setZoom(TAP_ZOOM, -px * (TAP_ZOOM - 1), -py * (TAP_ZOOM - 1));
  }
  function center() {
    var r = frame.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function onDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    try {
      stage.setPointerCapture(e.pointerId);
    } catch (err) {
      /* ignore */
    }
    var ids = Object.keys(pointers);
    if (ids.length === 2) {
      var a = pointers[ids[0]];
      var b = pointers[ids[1]];
      var c = center();
      var mid = { x: (a.x + b.x) / 2 - c.x, y: (a.y + b.y) / 2 - c.y };
      pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: st.s, qx: (mid.x - st.x) / st.s, qy: (mid.y - st.y) / st.s };
      drag = null;
      stage.classList.add('is-dragging');
    } else if (ids.length === 1) {
      drag = { x: e.clientX, y: e.clientY, tx: st.x, ty: st.y, moved: false, t: Date.now(), type: e.pointerType };
      stage.classList.add('is-dragging');
    }
  }

  function onMove(e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (pinch && ids.length >= 2) {
      var a = pointers[ids[0]];
      var b = pointers[ids[1]];
      var c = center();
      var s = clamp((pinch.s * (Math.hypot(a.x - b.x, a.y - b.y) || 1)) / pinch.d, 1, MAX_ZOOM);
      var mx = (a.x + b.x) / 2 - c.x;
      var my = (a.y + b.y) / 2 - c.y;
      setZoom(s, mx - pinch.qx * s, my - pinch.qy * s); // keep the point under the fingers fixed
      return;
    }
    if (!drag) return;
    var dx = e.clientX - drag.x;
    var dy = e.clientY - drag.y;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) drag.moved = true;
    if (st.s > 1.01) setZoom(st.s, drag.tx + dx, drag.ty + dy);
    else if (items.length > 1) stage.style.transform = 'translateX(' + dx * 0.4 + 'px)'; // swipe preview
  }

  function onUp(e) {
    delete pointers[e.pointerId];
    var left = Object.keys(pointers).length;
    if (pinch) {
      if (left < 2) {
        pinch = null;
        if (st.s < 1.05) setZoom(1, 0, 0);
        if (left === 1) {
          var k = Object.keys(pointers)[0];
          drag = { x: pointers[k].x, y: pointers[k].y, tx: st.x, ty: st.y, moved: true, t: 0, type: 'touch' };
        } else {
          stage.classList.remove('is-dragging');
        }
      }
      return;
    }
    if (!drag) return;
    var d = drag;
    drag = null;
    stage.classList.remove('is-dragging');
    var dx = e.clientX - d.x;
    var dy = e.clientY - d.y;
    if (!d.moved) {
      if (d.type === 'mouse') {
        zoomAt(e.clientX, e.clientY); // click to zoom in / out
      } else {
        var now = Date.now();
        if (now - lastTap.t < 320 && Math.abs(e.clientX - lastTap.x) < 30 && Math.abs(e.clientY - lastTap.y) < 30) {
          lastTap.t = 0;
          zoomAt(e.clientX, e.clientY); // double-tap
        } else {
          lastTap = { t: now, x: e.clientX, y: e.clientY };
        }
      }
      return;
    }
    if (st.s <= 1.01) {
      stage.style.transform = '';
      if (Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      else if (dy > 120 && Math.abs(dy) > Math.abs(dx) * 1.5 && d.type !== 'mouse') close(); // swipe down to close
    }
  }

  function onCancel(e) {
    delete pointers[e.pointerId];
    pinch = null;
    drag = null;
    stage.classList.remove('is-dragging');
    if (st.s <= 1.01) stage.style.transform = '';
  }

  // ---- buttons, keyboard ----
  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-lb-close]')) return close();
    if (t.closest('[data-lb-prev]')) return show(index - 1);
    if (t.closest('[data-lb-next]')) return show(index + 1);
    if (t.closest('[data-lb-zoom]')) {
      var c = center();
      return zoomAt(c.x, c.y);
    }
    if (t.closest('[data-lb-share]')) return share();
    if (t.closest('[data-lb-fullscreen]')) return toggleFullscreen();
    // a click on the dark area around the photo closes the viewer
    if (!t.closest('.doro-lb__frame') && !t.closest('.doro-lb__bar')) close();
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    } else if (e.key === 'ArrowLeft') {
      show(index - 1);
    } else if (e.key === 'ArrowRight') {
      show(index + 1);
    } else if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) {
        return !b.hidden && b.offsetParent !== null;
      });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) {
        e.preventDefault();
        f[f.length - 1].focus();
      } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
        e.preventDefault();
        f[0].focus();
      }
    }
  }

  function share() {
    var url = window.location.href.split('#')[0];
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(
        function () {
          toast('Link copied');
        },
        function () {
          toast('Could not copy the link');
        }
      );
    }
  }

  function toggleFullscreen() {
    if (document.fullscreenElement) document.exitFullscreen().catch(function () {});
    else if (lb.requestFullscreen) lb.requestFullscreen().catch(function () {});
  }

  function toast(msg, ms) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, ms || 1800);
  }

  // Open the viewer instead of Dawn's modal when a product photo is clicked or tapped.
  document.addEventListener(
    'click',
    function (e) {
      var toggle = e.target.closest && e.target.closest('media-gallery .product__media-toggle[data-media-id]');
      if (!toggle) return;
      var list = collectItems();
      var id = toggle.getAttribute('data-media-id');
      var i = -1;
      for (var k = 0; k < list.length; k++) if (String(list[k].id) === String(id)) i = k;
      if (i < 0) return; // videos / 3D models keep Dawn's default behaviour
      e.preventDefault();
      e.stopPropagation();
      open(i, toggle);
    },
    true
  );

  window.doroLightbox = { open: open, close: close };
})();
